import { useState } from "react"
import { useRouter } from "next/router"
import { Box, Text } from "@chakra-ui/react"
import CreateAccountForm from "components/registration/createAccountForm"
import CustomLoginForm from "components/registration/customLoginForm"
import logger from "util/loggers/loggerBrowser"
import scrubPassword from "components/registration/scrubPassword"
import oktaRegistrationRedirect from "lib/oktaRegistrationRedirect"

export default function CreateAccountSection({ redirectUrl, pardotFormHandler, slug, locale, preview = false, oauth, vendorOktaClientId }) {
    const router = useRouter()
    const [errorMessage, setErrorMessage] = useState("")

    const onSuccess = async userFields => {
        logger.info("User created successfully", scrubPassword(userFields))
        const errorMsg = await oktaRegistrationRedirect({
            username: userFields.email,
            password: userFields.password,
            redirectUrl,
            pardotFormHandler,
            slug,
            preview,
            router,
            oauth,
            vendorOktaClientId,
        })
        if (errorMsg) {
            setErrorMessage("We could not log you in. Please use the form to login.")
        }
    }

    const onError = errorMsg => {
        logger.error("CreateAccountSection: User login failed")
        setErrorMessage(errorMsg)
    }

    // if auto-login fails, then display the sign-in widget
    if (errorMessage) {
        return (
            <Box>
                <Text color="error" mb={6}>
                    {errorMessage}
                </Text>
                <CustomLoginForm redirectUrl={redirectUrl} preview={preview} />
            </Box>
        )
    }

    return (
        <Box>
            <CreateAccountForm onSuccess={onSuccess} onError={onError} locale={locale} preview={preview} />
        </Box>
    )
}
